import {
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Tab} from '../../data/tab';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';
import {TabbingService} from '../../services/tabbing.service';
import {NavigationService} from '../../../app-common/services/navigation.service';

@Component({
  selector: 'app-tab',
  templateUrl: './app-tab.component.html',
  styleUrls: ['./app-tab.component.css']
})
export class AppTabComponent implements OnInit {
  @ViewChild('vc', { read: ViewContainerRef, static: false }) vc: ViewContainerRef | undefined;
  @Input() tab: Tab;
  @Input() forceVisible: boolean = false;
  prevComponentType: any;
  AppWindowState = AppWindowState;
  componentRef: any;

  get showSkeleton(): boolean {
    return !this.tab.navigationData.loaded;
  }

  constructor(public appStateService: AppStateService,
              private elementRef: ElementRef,
              private navigationService: NavigationService,
              private componentFactoryResolver: ComponentFactoryResolver,
              public tabbingService: TabbingService) {
  }

  ngOnInit() {
    this.navigationService.subscribe(this.tab, () => {
      this.onNavigation();
    });
  }

  async onNavigation() {
    const component = this.tab.navigationData.route.component;
    if (!component) {
      return;
    }
    if (!this.vc) {
      return;
    }
    if (this.prevComponentType === undefined) {

    } else if (this.prevComponentType === component) {
      return;
    } else {
      this.vc.clear();
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    this.componentRef = this.vc.createComponent(factory);
    this.prevComponentType = component;
    if (this.componentRef.instance.onNavigation) {
      this.componentRef.instance.tab = this.tab;
      this.componentRef.instance.onNavigation(this.tab.navigationData);
    }
  }
}
